import { ReactNode } from "react";

import Typography from "../typography/Typography";
import styles from "./classification-reason.module.scss";

type Props = {
  icon?: ReactNode;
  label?: string;
  title: ReactNode;
  onClick?: () => void;
};

const ClassificationReason = ({ icon, label, title, onClick }: Props) => (
  <section
    data-testid="report_summary_classification_reason_container"
    className={styles.classification_reason_wrapper}
    onClick={onClick}
  >
    <div className={styles.classification_reason}>
      {icon}
      <Typography
        variant="h5"
        tag="span"
        className={styles.classification_reason_title}
        data-testid="report_summary_classification_reason_title"
      >
        {title}
      </Typography>
    </div>
    <Typography
      tag="span"
      variant="body4"
      className={styles.classification_reason_source}
      data-testid="report_summary_classification_reason_source"
    >
      {label}
    </Typography>
  </section>
);

export default ClassificationReason;
